module.exports = __webpack_public_path__ + "img/minus-yellow.fe811ab4.svg";